module.exports = __webpack_public_path__ + "img/BIT_white20.4cdc5436.jpg";